import {resolve} from './index';

export const events = () => next => action => {
  next(action);
  resolve(action);
};
